/* ClinicianPageTable auto-generated by npm run generator */
import { capitalize, Link, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Typography } from "@material-ui/core"
import MoreVert from "@material-ui/icons/MoreVert"
import { Client } from "@qlarity/common"
import clsx from "clsx"
import { observer } from "mobx-react"
import React, { CSSProperties } from "react"
import { Link as RouterLink, useHistory } from "react-router-dom"
import { PATHS } from "Router"
import { Clinician } from "store/modules/Auth"
import Store from "store/Store"
import InviteClient from "./dialogs/InviteClient"
import ClientMenu from "./dropdowns/ClientMenu"
import { useFilterMenu } from "./dropdowns/FilterMenu"
interface ClinicianPageTableProps {
    className?: string
    style?: CSSProperties
    children?: React.ReactNode
    clinician: Clinician
    clients?: Client[]
}

const useStyles = makeStyles((theme: Theme) => ({
    clinicianPageTableMolecule: {
        border: `1px solid ${theme.palette.secondary.main}`,
        padding: theme.spacing(4),
    },
    header: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: theme.spacing(2),
        gridAutoColumns: "max-content",
        alignItems: "center",
        gridTemplateColumns: "auto auto 1fr",
    },
    filter: {
        justifySelf: "flex-end",
        minWidth: 130,
    },
    row: {
        cursor: "pointer",
    },
}))

const ClinicianPageTable: React.FC<ClinicianPageTableProps> = (props) => {
    const history = useHistory()
    const classes = useStyles()
    const className = clsx(classes.clinicianPageTableMolecule, props.className)
    const { FilterMenu, filteredUsers } = useFilterMenu(props.clients)
    const headers = ["Name", "Case ID", "Last Activity", "Current Module", "Last Mood", "Status", <MoreVert />]

    return (
        <div className={className} style={props.style}>
            <div className={classes.header}>
                <Typography variant="h5">Client List: {props.clinician.displayName}</Typography>
                <InviteClient clinician={props.clinician} />
                <FilterMenu />
            </div>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {headers.map((header) => (
                                <TableCell key={header.toString()}>{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredUsers?.map(
                            (client, i) =>
                                client &&
                                // caseId gets populated after the initial creation, this fixes key errors link creation errors
                                client.caseId && (
                                    <TableRow key={client.caseId} hover onClick={() => history.push(PATHS.CLIENT(client))} className={classes.row}>
                                        <TableCell>
                                            {/* PointerEvents set to none to stop propagation but link is still here for tabbing and a11y */}
                                            <Link component={RouterLink} to={PATHS.CLIENT(client)} color="textPrimary" style={{ pointerEvents: "none" }}>
                                                {client.displayName}
                                            </Link>
                                        </TableCell>
                                        <TableCell>{Store.clientStore.getShortId(client)}</TableCell>
                                        <TableCell>{Store.clientStore.findLastActivity(client)?.toLocaleString()}</TableCell>
                                        <TableCell>{Store.clientStore.findCurrentModule(client)?.name}</TableCell>
                                        <TableCell>{Store.clientStore.findLastMood(client)?.moodName}</TableCell>
                                        <TableCell>{capitalize(client.status)}</TableCell>
                                        <TableCell>
                                            <ClientMenu client={client} clinician={props.clinician} />
                                        </TableCell>
                                    </TableRow>
                                )
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default observer(ClinicianPageTable)
